import { useEffect, useState } from 'react';

import { useApp } from '@/context/app';
import { useSocketIO } from '@/context/socket';
import { Scanner } from '@hubmaster/components';

import { Product } from './Product';
import { SearchModal } from './SearchModal';

export function Main() {
	const [loading, setLoading] = useState(false);
	const [barcode, setBarcode] = useState('');
	const [directProduct, setDirectProduct] = useState<any | null>(null);
	const { statusSocket } = useSocketIO();
	const { isTV } = useApp();

	function updateBarcode(value: string) {
		if (value[0] === '2' && value.length > 7) {
			value = value.substring(0, 7);
		}

		// Clear direct product when a new scan comes in
		setDirectProduct(null);
		setBarcode(value);
	}

	useEffect(() => {
		if (!isTV) {
			return;
		}

		const time = setTimeout(() => {
			updateBarcode('');
		}, 1000 * 12);

		return () => {
			clearTimeout(time);
		};
	}, [barcode]);

	return (
		<div className="relative flex h-full w-full flex-col items-center justify-center">
			<Product
				barcode={barcode}
				isLoading={setLoading}
				loading={loading}
				directProduct={directProduct}
			/>
			<div
				className="mx-auto mt-6 flex gap-3"
				style={{
					display: isTV ? 'none' : 'flex',
				}}
			>
				<Scanner
					onRead={updateBarcode}
					loading={loading}
					showButton={statusSocket === 'connected'}
					className="h-12 font-semibold"
				/>

				<SearchModal
					onSelect={(product) => {
						setBarcode('');
						setDirectProduct(product);
					}}
					onBarcode={(value) => {
						setDirectProduct(null);
						updateBarcode(value);
					}}
					disabled={statusSocket !== 'connected'}
				/>
			</div>
		</div>
	);
}
